var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { connect as reduxConnect } from 'react-redux';
import { postUiException } from './actions/response.actions';
export var connect = function (mapStateToProps, mapDispatchToProps, mergeProps) {
    if (mapStateToProps === void 0) { mapStateToProps = null; }
    if (mapDispatchToProps === void 0) { mapDispatchToProps = null; }
    var args = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args[_i - 3] = arguments[_i];
    }
    var mergingProps = function (state, dispatchers, ownProps) {
        if (mergeProps) {
            try {
                return mergeProps.apply(void 0, __spreadArray([state, dispatchers, ownProps], args));
            }
            catch (e) {
                ownProps.reportErrors(e);
                throw (e);
            }
        }
        return __assign(__assign(__assign({}, state), dispatchers), ownProps);
    };
    return function (Component) {
        var connectedApp = reduxConnect.apply(void 0, __spreadArray([mapStateToProps, mapDispatchToProps, mergingProps], args))(Component);
        return reduxConnect(null, { reportErrors: postUiException })(connectedApp);
    };
};
